/* @flow */

import type { NETGEM_API_V8_FEED_RAW_ITEM } from '../../libs/netgemLibrary/v8/types/FeedItem';
import type { NETGEM_API_V8_RAW_FEED } from '../../libs/netgemLibrary/v8/types/FeedResult';
import type { NETGEM_API_V8_PURCHASE_INFO } from '../../libs/netgemLibrary/v8/types/PurchaseInfo';
import type { BO_PURCHASE_LIST_TYPE } from '../../redux/netgemApi/actions/videofutur/types/purchase';

// Index of episode number in episode id
const EPISODE_NUMBER_INDEX = 4;

const isPackPurchased = (purchaseInfo: NETGEM_API_V8_PURCHASE_INFO, purchaseList: BO_PURCHASE_LIST_TYPE | null): boolean => {
  if (purchaseList === null) {
    return false;
  }

  const [
    {
      settings: { distributorId, vtiId },
    },
  ] = purchaseInfo;
  const { [distributorId]: purchaseListForDistributor } = purchaseList;

  if (purchaseListForDistributor === undefined) {
    return false;
  }

  // Look into purchased items for the right pack vtiId
  return Object.values(purchaseListForDistributor).find(({ packVtiId }) => packVtiId === vtiId) !== undefined;
};

const getFirstEpisodeLocation = (packElements: NETGEM_API_V8_RAW_FEED): NETGEM_API_V8_FEED_RAW_ITEM | null => {
  const [{ elements }] = packElements;

  if (!elements) {
    return null;
  }

  for (const episode of elements) {
    const { id } = episode;
    const parts = id.split('/');

    if (Number(parts[EPISODE_NUMBER_INDEX]) === 1) {
      return episode;
    }
  }

  return null;
};

export { getFirstEpisodeLocation, isPackPurchased };
